import { createStore } from 'vuex'

export default createStore({
  state: {
    refreshInfo:false
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
